import { render, staticRenderFns } from "./legacy_job_item.vue?vue&type=template&id=3e388f6b"
import script from "./legacy_job_item.vue?vue&type=script&lang=js"
export * from "./legacy_job_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports